import React from "react";
import { observer, inject } from "mobx-react";
import dateFormat from 'dateformat';

import { optionsPostMessageStatus } from '../forms/PostMessageForm'
import TextTruncate from './TextTruncate'
import Swipeout from 'rc-swipeout';

@inject('postStore')
@observer
export default class PostMessage extends React.Component {    

    render() {
        let { message, isLoggedIn, postStore, deleteCallback } = this.props;        
        const d = message.createddatetime;
        return (
            <Swipeout
                disabled={!isLoggedIn}
                right={[
                    {
                        text: 'Delete',
                        onPress: () => postStore.deletePostMessage(message, deleteCallback),
                        className: 'delete-post-message'
                    }
                ]}
            >
                <div className="post-message">
                    <div className="post-message-desc"><div className="post-message-status">{optionsPostMessageStatus.filter(status => status.value === message.status)[0].label} - </div><TextTruncate text={message.text} truncateText="..." line={2} textTruncateChild="" containerClassName="post-message-text" /></div>
                    <div className="post-message-date">{d && (d.toLocaleTimeString() + " " + d.toDateString())}</div>
                    {isLoggedIn && <button className="delete-post-message" onClick={() => postStore.deletePostMessage(message, deleteCallback)}>Delete</button>}
                </div>
            </Swipeout>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/PostMessage.jsx